<template>
  <ClientOnly>
    <TShare :networks="getNetworks()"></TShare>
  </ClientOnly>
</template>

<script setup lang="ts">
import type { networksType } from '~~/modules/design-system/components/t-share/constants'
import { getNoParamsCurrentUrl } from '~/utils/getNoParamsCurrentUrl'

const getNetworks = (): networksType => {
  const noParamsCurrentUrl = getNoParamsCurrentUrl()
  return [
    {
      kind: 'whatsapp',
      url:
        noParamsCurrentUrl +
        '?utm_medium=share&utm_campaign=cabecera&utm_source=whatsapp',
      title: t('menu.share_menu.whatsapp.title'),
      message: '',
    },
    {
      kind: 'copy',
      title: t('menu.share_menu.copy.title'),
      url:
        noParamsCurrentUrl +
        '?utm_medium=share&utm_campaign=cabecera&utm_source=copiar_enlace',
      copiedText: t('menu.share_menu.copy.copiedText'),
    },
  ]
}
</script>
